import { gql } from '@apollo/client';
import client from './ApolloClient'; // Import your Apollo Client setup

// Define the GraphQL mutation for login
const LOGIN_MUTATION = gql`
  query Login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      access_token
      user_status
      roleType
      name
      id
      
    }
  }
`;

const LOGIN_BY_EMAIL_QUERY = gql`
  query LoginByEmail($email: String!) {
    loginByEmail(email: $email) {
      access_token
      user_status
      roleType
      name
      id
      
    }
  }
`;

const FORGOT_PASSWORD_MUTATION = gql`
  mutation ForgotPassword($email: String!) {
    forgotPassword(data: { email: $email }) {
      success
      message
    }
  }
`;


const RESET_PASSWORD_MUTATION = gql`
  mutation ResetPassword($token: String!,$newPassword: String!) {
    resetPassword(data: { token: $token , newPassword: $newPassword }) {
      success
      message
    }
  }
`;


export const REGISTER_USER_MUTATION = gql`
  mutation RegisterUser($data: UserCreateInput!) {
    registerUser(data: $data) {
      id
      email
      name
      userRoleId
      userStatus
      phoneNumber
      role {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`;

const CREATE_USER = gql`
  mutation createUser($data: UserCreateInput!) {
    registerUser(data: $data) {
       id
      email
      name
      userRoleId
      userStatus
      phoneNumber
      role {
        id
        name
      }
      createdAt
      updatedAt
    }
  }
`;

// Function to handle login
export const loginService = async (email, password) => {
  try {
    const response = await client.mutate({
      mutation: LOGIN_MUTATION,
      variables: { email, password },
    });
    console.log(response);

    const token = response.data.login.access_token;
    const user_status = response.data.login.user_status;
    const roleType = response.data.login.roleType;
    const name = response.data.login.name;
    const userId = response.data.login.id; // Assuming userId is returned in the response

    // Save the token in localStorage
    setAuthDataInLocalStorage(token, roleType, name, userId); // Save token and other data in localStorage
    return { token, user_status };
  } catch (error) {
    console.error('Login failed:', error);
    throw error; // Re-throw the error so it can be handled in the component
  }
};

// Function to handle login by email
export const loginEmailService = async (email) => {
  try {
    const response = await client.query({
      query: LOGIN_BY_EMAIL_QUERY,
      variables: { email },
      fetchPolicy: 'network-only', // Ensure we don't use cached data
    });
    console.log(response);
    const data = response.data.loginByEmail; 
    
    const token = data.access_token;
    const user_status = data.user_status;
    const roleType = data.roleType;
    const name = data.name;
    const userId = data.id;

    // Save the token in localStorage
    setAuthDataInLocalStorage(token, roleType, name, userId); // Save token and other data in localStorage
    return { token, user_status, roleType };
  } catch (error) {
    console.error('Login failed:', error);
    throw error; // Re-throw the error so it can be handled in the component
  }
};

export const forgotPasswordService = async (email) => {
  try {
    const response = await client.mutate({
      mutation: FORGOT_PASSWORD_MUTATION,
      variables: { email },
    });
    console.log(response);

    const message = response.data.forgotPassword.message;
    const success = response.data.forgotPassword.success;
   
   
    return { message, success };
  } catch (error) {
    console.error('reset password failed:', error);
    throw error; // Re-throw the error so it can be handled in the component
  }
}

export const resetPasswordConfirmService = async (token,newPassword) => {
  try {
    const response = await client.mutate({
      mutation: RESET_PASSWORD_MUTATION,
      variables: {token, newPassword },
    });
    console.log(response);

    const message = response.data.resetPassword.message;
    const success = response.data.resetPassword.success;
   
   
    return { message, success };
  } catch (error) {
    console.error('reset password failed:', error);
    throw error; // Re-throw the error so it can be handled in the component
  }
}


const setAuthDataInLocalStorage = (token, roleType, name, userId) => {
  localStorage.setItem('authToken', token);
  localStorage.setItem('roleType', roleType);
  localStorage.setItem('userName', name);
  localStorage.setItem('userId', userId);
};

//helper function to get auth data from localStorage
export const getAuthDataFromLocalStorage = () => {
  const token = localStorage.getItem('authToken');
  const roleType = localStorage.getItem('roleType');
  const name = localStorage.getItem('userName');
  const userId = localStorage.getItem('userId');
  return { token, roleType, name, userId };
};

//helper to get userId from localStorage
export const getUserId = () => {
  const userId = localStorage.getItem('userId');
  return userId;
};

// Function to handle user registration
export async function userRegister(email, name, password, phoneNumber, role) {
  // 1) normalize the incoming role
  const upper = String(role).toUpperCase(); // e.g. "editor" → "EDITOR"

  // now pass both roleType and connect.name as the same UPPercase string
  const userData = {
    email,
    name,
    password,
    userStatus: "INACTIVE",   // or whatever default
    phoneNumber,
    roleType: upper,           // for the enum
    role: { connect: { name: upper } }  // for the nested relation
  };

  const { data } = await client.mutate({
    mutation: REGISTER_USER_MUTATION,
    variables: { data: userData },
    context: {
      headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` }
    }
  });

  return data.registerUser;
}

export async function createUser(email, name, password, phoneNumber, role) {
  // same normalization
  const upper = String(role).toUpperCase();

  const userData = {
    email,
    name,
    password,
    userStatus: "INACTIVE",
    phoneNumber,
    roleType: upper,
    role: { connect: { name: upper } }
  };

  const { data } = await client.mutate({
    mutation: CREATE_USER,
    variables: { data: userData },
    context: {
      headers: { Authorization: `Bearer ${localStorage.getItem('authToken')}` }
    }
  });

  return data.registerUser;
}

const handleCreateUser = async () => {
  try {
    const userData = {
      name: "demo",
      email: "hello@gmail.commee",
      password: "12345678",
      userStatus: "ACTIVE",
      roleType: "EDITOR",
      role: { connect: { name: "editor" } },
    };
    const newUser = await createUser(userData);
    console.log("Created User:", newUser);
  } catch (error) {
    console.error("Failed to create user:", error);
  }
};